import { render, staticRenderFns } from "./Dessins.vue?vue&type=template&id=7871013e&"
import script from "./Dessins.vue?vue&type=script&lang=js&"
export * from "./Dessins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports